
import { io } from "socket.io-client";
const socket = io('https://api.sweepydo.in');
export default socket;
